module.exports = __webpack_public_path__ + "static/img/7.9c40b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/7.png
// module id = l2Sg
// module chunks = 0